export default "__VITE_ASSET__52fadbb5__"